import { gql } from '@apollo/client'

import { quoteFields } from '../../quotes/core/quotes.queries'

export const customerFields = `
firstName
lastName
email
phoneNumber {
  number
}
`

const requestFields = `
residence {
  residenceType
  residenceRooms {
    key
    value
  }
  residenceRoomsPrefilled
}
content {
  nbBoxes
  furnitureRatio
  specialItems {
    key
    value
  }
  specialItemsPrefilled
}
size {
  volumeCubicFeet
  weightPounds
}
requirements {
  nbTrucks {
    key
    value
  }
  nbMen
  movingLabourTime
  packingLabourTime
}
`

const locationFields = `
id
address {
  placeId
  placeTextLine1
  placeTextLine2
  country
  street
  apartment
  city
  region
  postalCode
}
coordinates {
  type
  coordinates
}
nbStairs
elevatorReservationRequired
elevatorReservationTime
walkDistanceMeters
parkingType
`

const locationsFields = `
origin {
  ${locationFields}
}
destination {
  ${locationFields}
}
stops {
  ${locationFields}
  description
  stopDurationHours
}
warehouse {
  ${locationFields}
}
`

const jobFields = `
id
dateTime {
  startDate
  endDate
  flexibleDate
  preferredTimeRanges
  selectedTimeRange
  selectedTime
}
moving {
  pickupLocations
  deliveryLocations
}
packing {
  location
}
resolved {
  timeZone
  timeline {
    arrivalTime
    actions {
      action
      locationId
      start
      end
    }
    departureTime
  }
  jobDurationSeconds
  transportDistanceMeters
  transportDurationSeconds
}
`

export const paymentRequestFields = `
gateway
gatewayId
createdAt
clientSecret
amount {
  price
  currency
}
`

export const noteAttachmentFields = `
id
createdAt
filename
mimeType
url
`

const noteFields = `
note
attachments {
  ${noteAttachmentFields}
}
`

const notesFields = `
fromCustomer {
  ${noteFields}
}
toCustomer {
  ${noteFields}
}
`

export const moveFields = `
id
publicId
locked
quoteAcceptedAt
customer {
  ${customerFields}
}
services
request {
  ${requestFields}
}
locations {
  ${locationsFields}
}
jobs {
  ${jobFields}
}
source {
  platform
}
accounting {
  paymentProfile {
    depositRequest {
      ${paymentRequestFields}
    }
    paymentRequest {
      ${paymentRequestFields}
    }
  }
  skipDeposit
}
promoCode {
  pendingPromoCode {
    id  
    code
    type
    value
    protected
  }
  appliedPromoCode {
    code
    type
    value
  }
}
notes {
  ${notesFields}
}
quotes {
  ${quoteFields}
}
selectedQuote {
  ${quoteFields}
}
deposit {
  id
  createdAt
  amount {
    price
    currency
  }
  isDeposit
  status
}
rating
`

export const getMove = gql`
query GetMove($movePublicId: String!) {
  getMove(movePublicId: $movePublicId) {
    ${moveFields}
  }
}
`
